import { Injectable, inject } from '@angular/core';
import { timer } from 'rxjs';
import { DataService } from 'src/data-store/data.service';
import { ConfigService } from './json-config.service';
import { EnvironmentKeys } from 'src/environments/environment-keys';
import { ELoadingEntity } from 'src/models/generic-store.model';
import { UserDataService } from 'src/data-store/user-data.service';

@Injectable({
  providedIn: 'root'
})
export class UserNotificationService {
  private dataService = inject(DataService);
  private configService = inject(ConfigService);
  private userDataService = inject(UserDataService);

  public constructor() {
    // todo: test error case
    timer(0, this.configService.getConfig(EnvironmentKeys.headerNotificationsBellUpdateInMiliseconds))
      .subscribe(() => {
        if (this.userDataService.loggedUser() && !this.dataService.appHasErrored(ELoadingEntity.NOTIFICATION_PROCESSED_SUM)) {
          this.dataService.getNewNotificationsCount();
        }
      });
  }
}
